export default __webpack_public_path__ + "static/media/red-mark.96d90eba.svg";